import React, { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router"
import useTitle from "@/hooks/useTitle"
import EtBtnFormBasic from "@/components/common/buttons/EtBtnFormBasic"
import PulseLoader from "react-spinners/PulseLoader"
import Modal from "@/components/common/modal/Modal"
import { useGetHabitsQuery, useDeleteHabitMutation } from "./habitsApiSlice"

const EtDeleteHabit = ({id, setActiveAdminView}) => {
  // First Created - 26 Jun 2025
  // Author - Atul Pandey
  // Inherited from impactTypes and repurposed

  // 1 - Set Title
  useTitle("Delete Habit")

  // 2 - extract the habit Id from the url
  // const { id } = useParams()
  // console.log("id:", id)

  // 3 - Extract the habit from the query to load the habit data
  const { habit } = useGetHabitsQuery("Habit", {
    selectFromResult: ({ data }) => ({
      habit: data?.entities[id],
    }),
  })

  // console.log('habit:', habit)

  // 4 - Check for returned data
  if (!habit) {
    return <PulseLoader color={"#ea580c"} />
  }

  // 5. Display data
  let content
  content = <EtDeleteHabitForm habit={habit} id={id} setActiveAdminView={setActiveAdminView}/> 
  return content
}

const EtDeleteHabitForm = ({habit={}, id=null,setActiveAdminView="" }) => {

  // 0 - validate data
  // console.log('habit - in delete form:', habit)
  // console.log('id - in delete form:', id)


  // 1 - set the variable for navigate
  const navigate = useNavigate()

 // 1a - Delete section modal 
 const [isModalOpen, setIsModalOpen] = useState(false)


  // 2 - set the mutation to create the new section data
  const[deleteHabit, {
    isLoading,
    isSuccess,
    isError,
    error,
  }] = useDeleteHabitMutation()

// 3 - set the form data object
const [formData, setFormData] = useState({
  habitName: habit.habitName,
})

//console.log('formData for update:', formData)

// 4 - Reset form upon successful submission
useEffect(() => {
  if(isSuccess) {
    setFormData({
      habitName: "",
    })

    setActiveAdminView('habits'); 
  }

},[isSuccess]) 

// 5 - Form field updates / change handling

const handleChange = (e) => {
  const { name, value, files } = e.target
  if (name === "pic") {
    setFormData(prevState => ({ ...prevState, pic: files[0] }))
  } else {
    setFormData(prevState => ({ ...prevState, [name]: value }))
  }
}

// Modal management functions
const handleOpenModal = () => setIsModalOpen(true)
const handleCloseModal = () => setIsModalOpen(false)

// 7 - Form Submit Logic
const handleConfirm = async (e) => {
  e.preventDefault()
  // handleCloseModal()

  // Initialize an object to collect the form data
  const habitData = {
    habitName: formData.habitName,
  }
    // No image, send other data as is
    try {
      habitData.id = id
      console.log("Form submitted.")
      // console.log('habitData', habitData)
      await deleteHabit(habitData).unwrap() // Dispatch the RTK Query mutation
      setActiveAdminView("habits");
    } catch (error) {
      console.error(error)
    } finally {
      handleCloseModal(); // ✅ Ensure modal closes even if there's an error.
    }
}

// 8 - Handle Cancel

const handleCancel = () => {
  
  setActiveAdminView('habits'); 
}


return (
  <div className="bg-gray-200 p-1 mx-auto mt-5 rounded-lg shadow-md shadow-black">
    {isLoading && <PulseLoader color={"#ea580c"} />}
    {isError && (
      <p className="text-orange-700 font-semi-bold py-2">
        {error?.data?.message}
      </p>
    )}
    <div className="bg-white p-1 m-1 rounded">
      <p className="p-1 m-1 font-bold font-poppins text-xl">Delete a Habit</p>

      <div className="bg-gray-200 rounded m-1 p-1">
        <form
          onSubmit={handleOpenModal}
          className="m-1 p-1 text-xs font-poppins"
        >
          
          <div id="habitName">
            <input
              type="text"
              name="habitName"
              placeholder="Enter the impact type name here"
              value={formData.habitName}
              onChange={handleChange}
              className="w-full rounded p-2 m-1"
            />
          </div>

          <div id="impacts" className="bg-white m-1 px-1 py-3 rounded">
            <EtBtnFormBasic
              name={"Delete"}
              type={"create"}
              handleClick={handleOpenModal}
            />
            <EtBtnFormBasic
              name={"Cancel"}
              type={"cancel"}
              handleClick={handleCancel}
            />
          </div>
        </form>
      </div>
    </div>
    <Modal isOpen={isModalOpen} onClose={handleCloseModal} onConfirm={handleConfirm} />
  </div>
)

}

export default EtDeleteHabit